import {countries} from '../helpers/countries';
import {applicantFields, studentNumberFields, premiumField, legalGuardianFields} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'msgis';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.detailedBeneficiaryGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      {
        key_path: ['application', 'additional_data', 'school'],
        as: 'School'
      },
      ...studentNumberFields('0')
    ], 
    contact_details_fields: [
      ...legalGuardianFields(false)
    ],
    dependent_fields: [
      ...applicantFields('*', [
          {value: 'dependent', text: 'Dependent Child'},
          {value: 'parent', text: 'Parent/Guardian'},
          {value: 'spouse', text: 'Spouse'}
        ]
      ),
      ...studentNumberFields('*'),
    ],
    coverage_fields: [
        {
            key_path: ['application', 'additional_data', 'coverage_type'],
            as: 'Plan Name',
            is_static_by_default: true
        },
        {
            key_path: ['application', 'additional_data', 'country_of_origin'],
            as: 'Home Country',
            type: 'dropdown',
            options: countries()
        },
        {
            key_path: ['application', 'additional_data', 'other_plan'],
            as: 'Other Insurance',
            type: 'dropdown',
            options: [
                { value: 'yes', text: 'Yes' },
                { value: 'no', text: 'No' }
            ],
            do_not_show_if: [{
                key_path: ['application', 'additional_data', 'other_plan'],
                value: undefined
            }]
        },
        {
            key_path: ['application', 'additional_data', 'name_of_other_plan'],
            as: 'Name of Other Plan',
            show_if: [{
                key_path: ['application', 'additional_data', 'other_plan'],
                value: 'yes'
            }]
        }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/clients/msgis.js